<div
  class="ui segment"
  style="
    padding-left: 0px;
    padding: 10px;
    margin-bottom: 10px;
    border: 0px;
    margin-top: 20px;
  "
>
  <div fxLayout="row" fxLayoutAlign="start stretch" style="align-items: center">
    <div>
      <h1
        style="
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          color: #505050;
        "
      >
        {{ application?.licenseNumber }}
      </h1>
    </div>
    <div>
      <h1
        style="
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          color: #505050;
          margin: 0px 25px;
        "
      >
        {{
          application?.nonNetworkOperatorLicenseType?.optionName
            ? application?.nonNetworkOperatorLicenseType?.optionName
            : application?.nonNetworkOperatorLicenseType
        }}
      </h1>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    style="margin-bottom: 0px; margin-top: 20px"
  >
    <div fxFlex="15%" style="align-self: center" class="table-data">
      <h1>Gross Revenue</h1>
      <p style="text-transform: capitalize">
        {{ application?.grossRevenue | amount }}
      </p>
    </div>
    <div fxFlex="15%" style="align-self: center" class="table-data">
      <h1>1% Payable</h1>
      <p>{{ application?.percentPayable | amount }}</p>
    </div>
    <div fxFlex="25%" style="align-self: center" class="table-data">
      <h1>Date Created</h1>
      <p>{{ application?.dateCreated | date: "d, MMMM y, h:mma" }}</p>
    </div>
    <div fxFlex="15%" style="align-self: center" class="table-data">
      <h1>Created By</h1>
      <p>
        {{ application?.createdBy | createdBy }}
      </p>
    </div>
    <div fxFlex="15%" style="align-self: center" class="table-data">
      <div class="ui mini basic primary dropdown" suiDropdown>
        <!-- <img src="assets/icons/Button.svg" alt="" /> -->
        <esl-button buttonType="primary" buttonSize="small" buttonState="outline" buttonActionState="default" [hasLine]="true" [hasSuffixIcon]="true" [buttonMenu]="'dropdownMenu'" [hasDropdown]="true" [isClickable]="true"></esl-button>
        <div class="left menu" suiDropdownMenu>
          <div class="item" *ngIf="!disabled" (click)="edit.emit(application)">
            Edit Assessment
          </div>
          <div class="item" (click)="onView.emit(application)">
            View Assessment
          </div>
          <div
            class="item"
            *ngIf="!disabled"
            (click)="deleteAssessment.emit(application)"
          >
            Delete Assessment
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
